import React, { useCallback, useEffect, useState } from "react";
import { useLoader } from "../../context/LoaderContext";
import { useUserDataContext } from "../../context/UserDataContext";
import { IMemberListData } from "../../exports/interfaces";
import { checkUser, fetchUserById } from "../../api/UserApi";
import { dynamicFailed } from "../../hooks/useToast";
import ProfileInformation from "../../components/user/member/ProfileInformation";
import { openLogin } from "../../exports/exports";
import { useNavigate } from "react-router-dom";

const MemberProfile = () => {
  const { setLoading } = useLoader();
  const [listMemberData, setListMemberData] = useState<IMemberListData[]>([]);
  const { userData, setUserData } = useUserDataContext();
  const navigate = useNavigate();

  const accessToken = localStorage.getItem("frcsit:access-token");
  useEffect(() => {
    setLoading(true);
    if (!userData) {
      if (accessToken === null || accessToken === undefined) {
        openLogin();
        return;
      }
      Promise.all([checkUser(accessToken)])
        .then(([userData]) => {
          setUserData(userData);
          // userData?.data?.status === "0" && navigate("/error");
          userData?.data?.roles[0]?.name !== "member" && openLogin();
        })
        .catch(() => {
          dynamicFailed("Server Error");
        });
    }
  }, [accessToken, navigate, setLoading, setUserData, userData]);

  const userId = userData?.data?.id;
  const getUserById = useCallback(() => {
  if (!userId) return;
  fetchUserById(userId)
    .then((data) => {
      setListMemberData(data);
      setTimeout(() => setLoading(false), 1000);
    })
    .catch(() => {
      dynamicFailed("Server Error");
      setTimeout(() => setLoading(false), 1000);
    });
}, [userId, setLoading]);
  useEffect(() => {
    if (userData) {
      getUserById();
    }
  }, [getUserById, setLoading, userData]);
  return (
    <ProfileInformation
      listMemberData={listMemberData}
      getUserById={getUserById}
    />
  );
};

export default MemberProfile;
